import React from 'react';
import PropTypes from 'prop-types';
import { useDrag } from 'react-dnd';

const DraggableWorkout = ({ workout }) => {
  const [, drag] = useDrag(() => ({
    type: 'WORKOUT',
    item: { workout },
  }));

  return (
    <div
      ref={drag}
      style={{
        border: '1px solid #ccc',
        padding: '10px',
        marginBottom: '10px',
        backgroundColor: '#f9f9f9',
        cursor: 'move',
      }}
    >
      <h4>{workout.name}</h4>
      <p>{workout.description}</p>
      <p>{workout.categoryName}</p>
      <p>{workout.equipmentNeeded ? 'Oprema potrebna' : 'Oprema nije potrebna'}</p>
    </div>
  );
};

DraggableWorkout.propTypes = {
  workout: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    equipmentNeeded: PropTypes.bool.isRequired,
    categoryName: PropTypes.string.isRequired,
  }).isRequired,
};

export default DraggableWorkout;
